import { useSubPath } from '../../app/useSubPath';
import { ExerciseRunner } from '../exercise/ExerciseRunner';
import { LessonPage } from '../lesson/LessonPage';
import { challengeCards, challengeConfig } from '../levels';
import { GroupTitle, LessonList, LevelGrid, ModulePage, type TabDef } from '../module/ModulePage';
import { CHALLENGES, LEVELS, levelConfig } from './levels';

type Tab = 'dersler' | 'antrenman' | 'meydan';
const TABS: TabDef<Tab>[] = [
  { id: 'dersler', label: 'Dersler', icon: 'book' },
  { id: 'antrenman', label: 'Antrenman', icon: 'target' },
  { id: 'meydan', label: 'Meydan okuma', icon: 'trophy' },
];

export function GitarSection() {
  const [sub, a] = useSubPath();
  if (sub === 'ders') return <LessonPage module="gitar" id={a ?? ''} />;
  if (sub === 'egz') {
    const level = LEVELS.find((l) => String(l.n) === a);
    if (level) return <ExerciseRunner config={() => levelConfig(level)} />;
  }
  if (sub === 'meydan' && a) {
    const ch = CHALLENGES.find((c) => c.id === a);
    if (ch) return <ExerciseRunner config={() => challengeConfig('gitar', ch)} />;
  }
  const tab: Tab = sub === 'antrenman' || sub === 'meydan' ? sub : 'dersler';
  return (
    <ModulePage id="gitar" levels={LEVELS} tabs={TABS} active={tab}>
      {tab === 'dersler' ? (
        <>
          <GroupTitle
            title="Önce öğren"
            sub="Kısa dersler kulaktan çalmanın yöntemini anlatır. Her dersin sonunda ilgili antrenmana geçebilirsin."
          />
          <LessonList module="gitar" />
        </>
      ) : tab === 'antrenman' ? (
        <>
          <GroupTitle
            title="Seviyeler"
            sub="Tek notadan uzun melodilere. Bir seviyede %70 ve üzeri doğrulukla iki yıldız alınca sıradakine geçmen önerilir."
          />
          <LevelGrid items={LEVELS} />
        </>
      ) : (
        <>
          <GroupTitle title="Meydan okumalar" sub="Süreli ve canlı oyunlar. Rekorların İlerleme sayfasında saklanır." />
          <LevelGrid items={challengeCards(CHALLENGES)} />
        </>
      )}
    </ModulePage>
  );
}
